import script from "./MenuView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuView.vue?vue&type=script&setup=true&lang=ts"

import "./MenuView.vue?vue&type=style&index=0&id=4ec449c5&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec449c5"]])

export default __exports__